import React from "react";
import { Typography } from '@mui/material';
import "./OffersOverview.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Trans, useTranslation } from "react-i18next";

import 'bootstrap/dist/css/bootstrap.min.css';



function OffersOverview() {
    const { t } = useTranslation();

  

    return (
        <div>
            <section className="bg-section-1">

                <Typography
                    variant="h4"
                    sx={{
                        color: "var(--taupe-fonc, #4AAE9B)",
                        textAlign: "left",
                        fontFamily: "Lato",
                        fontSize: "18px",
                        fontStyle: "normal",
                        fontWeight: 400,
                    }}>


                    {t("offersTitle1")}
                </Typography>
                <Typography
                    variant="h4"
                    sx={{
                        color: "#3F4C52",
                        textAlign: "left",
                        fontFamily: "DM Serif Display",
                        fontSize: {
                            xs: '6vw', // Font size for extra small screens
                            sm: '6vw', // Font size for small screens
                            md: '6vw', // Font size for medium screens
                            lg: '3.5vw', // Font size for large screens
                            xl: '2.5vw' // Font size for extra large screens
                        },
                        fontStyle: "normal",
                        fontWeight: 400,
                    }}>
                    <Trans
                        i18nKey="offersTitle2"
                        components={{ 1: <br />, 3: <br /> }}
                    />
                </Typography>
                <Typography
                    variant="h4"
                    sx={{
                        color: "var(--taupe-fonc, #2E2E2E)",
                        textAlign: "left",
                        fontFamily: "Lato",
                        fontSize: "18px",
                        fontStyle: "normal",
                        fontWeight: 400,
                    }}>
                    <br></br>

                    <Trans
                        i18nKey="offersDescription"
                        components={{
                            0: <br />, 2: <br />, 4: <br />, 6: <br />, 8: <br />, 10: <br />, 12: <br />
                        }}
                    />
                </Typography>

                <div className="div-more-boutique">
                    <center>
                        <a
                            href="https://yanacom.fr/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn-more-boutique">
                                {t("boutiqueButton")}
                            </button>
                        </a>
                    </center>
                </div>

            </section>

        </div>

    );
}

export default OffersOverview;
